//Check Mobile Devices
var checkMobile = function(){
    var isTouch = ('ontouchstart' in document.documentElement);
    if ( isTouch ) {
      $('html').addClass('touch');
    }
    else {
      $('html').removeClass('touch');
    };
  
};
  //Execute Check
checkMobile();

$(document).ready(function() {

    $("a.contactLink").fancybox({
        wrapCSS : 'contact-opened'
    }); 
  
  
//   $('.megaMenuTitleLink a').click (function (event) {
//     var containerwidth = $( window ).width();
//     if(containerwidth<970){
//       event.preventDefault();    
//     }
    
//   $(this).closest('.megaMenuWrapper').find('.list-unstyled').toggle();  
//   });

    $(".videoLink").fancybox({
        maxWidth	: 800,
        maxHeight	: 600,
        fitToView	: true,
        autoSize	: true,
        closeClick	: true,
        openEffect	: 'elastic',
        closeEffect	: 'elastic'
    }); 

    $('.sectionTestimonial .testimonialSlider').slick({
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [
            {
            breakpoint: 1199,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,
                dots: false
            }
        },
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                dots: false
            }
        },
        {
            breakpoint: 768,
            settings: {
            slidesToShow: 2,
            slidesToScroll: 2
            }
        },
        {
            breakpoint: 575,
            settings: {
            slidesToShow: 1, 
            slidesToScroll: 1
            }
        }
        ]
    });
    $('.gallerySlider').slick({
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 7,
        slidesToScroll: 1,
        responsive: [
            {
            breakpoint: 1199,
            settings: {
                slidesToShow: 6,
                slidesToScroll: 1,
                infinite: true,
                dots: false
            }
        },
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 6,
                slidesToScroll: 1,
                dots: false
            }
        },
        {
            breakpoint: 768,
            settings: {
            slidesToShow: 4,
            slidesToScroll: 1
            }
        },
        {
            breakpoint: 480,
            settings: {
            slidesToShow: 4,
            slidesToScroll: 1
            }
        }
        ]
    });

    $('.productMainSlider .sliderMain').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        asNavFor: '.sliderNav'
    });
    $('.productMainSlider .sliderNav').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        asNavFor: '.sliderMain',
        dots: false,
        focusOnSelect: true,
        responsive: [
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false
                }
            },
            {
            breakpoint: 992,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
                infinite: true,
                dots: false
            }
            },
            {
            breakpoint: 767,
            settings: {
                centerMode: false,
                slidesToShow: 4,
                slidesToScroll: 1
            }
            },
            {
            breakpoint: 480,
            settings: {
                centerMode: false,
                slidesToShow: 3,
                slidesToScroll: 1   
            }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]
    });
    
    $('.quickviewMainSlider .sliderMain').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true, 
        asNavFor: '.sliderNav'
    });
    $('.quickviewMainSlider .sliderNav').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        asNavFor: '.sliderMain',
        dots: false,
        focusOnSelect: true,
        responsive: [
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false
                }
            },
            {
            breakpoint: 992,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
                infinite: true,
                dots: false
            }
            },
            {
            breakpoint: 767,
            settings: {
                centerMode: false,
                slidesToShow: 4,
                slidesToScroll: 1
            }
            },
            {
            breakpoint: 480,
            settings: {
                centerMode: false,
                slidesToShow: 3,
                slidesToScroll: 1   
            }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]
    });

    $('.stepBox .stepContent').matchHeight();
    $('.sectionCategories .collectionBox').matchHeight();

    $('.collapse').on('shown.bs.collapse', function () {
        $(this).parents('.card').addClass('active');
    });

    $('.collapse').on('hidden.bs.collapse', function () {
        $(this).parents('.card').removeClass('active');
    });

    $(document).mouseup(function(e) {
        var container = $(".headerNav");
        if (!container.is(e.target) && container.has(e.target).length === 0) 
        {
            $('header').removeClass('opened');
            $('body').removeClass('menu-opened');
        }
    });

    function resolveQtyInput($btn) {
        var $adj = $btn.is('.qtyplus') ? $btn.prev('input') : $btn.next('input');
        if ($adj.length) return $adj;
        var field = $btn.attr('field');
        if (!field) return $();
        var el = document.getElementById(field);
        return el ? $(el) : $();
    }

    var qtyStepApplying = false;
    function runQtyStepOnce($btn, e) {
        if ($btn.closest('form[action="/cart"]').length) return;
        if (qtyStepApplying) {
            if (e) {
                e.preventDefault();
                e.stopImmediatePropagation();
            }
            return;
        }
        if (typeof navigator !== 'undefined' && navigator.maxTouchPoints > 0) {
            var t = Date.now();
            var last = $btn.data('qtyLastApplied') || 0;
            if (t - last < 320) {
                if (e) {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                }
                return;
            }
            $btn.data('qtyLastApplied', t);
        }
        qtyStepApplying = true;
        try {
            applyQtyStep($btn);
        } finally {
            setTimeout(function () {
                qtyStepApplying = false;
            }, 0);
        }
    }

    function applyQtyStep($btn) {
        var $input = resolveQtyInput($btn);
        if (!$input.length) return;
        var currentVal = parseInt($input.val(), 10);
        if ($btn.is('.qtyplus')) {
            if (!isNaN(currentVal)) {
                $input.val(currentVal + 1);
            } else {
                $input.val(1);
            }
        } else {
            if (!isNaN(currentVal) && currentVal > 1) {
                $input.val(currentVal - 1);
            } else {
                $input.val(1);
            }
        }
    }

    $(document)
        .off('click.qtyDelta touchend.qtyDelta', '.qtyplus, .qtyminus')
        .on('touchend.qtyDelta', '.quantityRange .qtyplus, .quantityRange .qtyminus', function (e) {
            var $btn = $(this);
            if ($btn.closest('form[action="/cart"]').length) return;
            e.preventDefault();
            $btn.data('qtyGhostClickUntil', Date.now() + 450);
            runQtyStepOnce($btn, e);
        })
        .on('click.qtyDelta', '.qtyplus, .qtyminus', function (e) {
            var $btn = $(this);
            if ($btn.closest('form[action="/cart"]').length) return;
            var until = $btn.data('qtyGhostClickUntil');
            if (until && Date.now() < until) {
                e.preventDefault();
                e.stopImmediatePropagation();
                return false;
            }
            $btn.removeData('qtyGhostClickUntil');
            e.preventDefault();
            runQtyStepOnce($btn, e);
        });

    jQuery('.cartLink').on('click',function(){
        jQuery('body').addClass('body-cart-open');
        jQuery('.slideCart').addClass('cart-open');
    });

    jQuery('.slideCart .close').on('click',function(){
        jQuery('body').removeClass('body-cart-open');
        jQuery('.slideCart').removeClass('cart-open'); 
    });

    if ($(window).width() < 992) {
        $(document).off('click.mobileDropdown', '.headerNav ul>li.dropdownItem>a')
                   .on('click.mobileDropdown', '.headerNav ul>li.dropdownItem>a', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var $li = $(this).parent('li');
            var $megaMenu = $li.children('.megaMenu');
            if ($li.hasClass('dropdownMenuOpen')) {
                $megaMenu.slideUp();
                $li.removeClass('dropdownMenuOpen');
            } else {
                $megaMenu.slideDown();
                $li.addClass('dropdownMenuOpen');
            }
        });
    }
  
  $("a[href='#top']").click(function(e) {
    e.preventDefault();
    $("html, body").animate({ scrollTop: 0 }, "slow");
    return false;
  });
});

$(document).on('click','.headerToggle #nav-icon',function () {
    $('header').addClass('opened');
    $('body').addClass('menu-opened');
});

$(document).on('click','.header.opened .closeIcon',function () {
    $('header').removeClass('opened');
    $('body').removeClass('menu-opened'); 
});


$(document).on('click','.megaMenuTitleLink',function (e) {
//     e.preventDefault();
  var dropDown = $(this).closest('.megaMenuWrapper').find('.list-unstyled');
  $(this).closest('.megaMenuContainer').find('.list-unstyled').not(dropDown).slideUp();
  
//     $('.megaMenuWrapper ul').hide();
//    $('.megaMenuWrapper').removeClass('megaMenuOpen');
  if ($(this).closest('.megaMenuWrapper').hasClass('megaMenuOpen')) {
      $(this).closest('.megaMenuWrapper').removeClass('megaMenuOpen');
    } else {
      $(this).closest('.megaMenuContainer').find('.megaMenuWrapper.megaMenuOpen').removeClass('megaMenuOpen');
      $(this).closest('.megaMenuWrapper').addClass('megaMenuOpen');
    }
   dropDown.stop(false, true).slideToggle();
//     $(this).parent('.megaMenuWrapper').children('ul').slideToggle();
//     $(this).parent('.megaMenuWrapper').toggleClass('megaMenuOpen');
});

/*Task 21F-YO4-I5Z*/
$(document).ready(function(){
  	$('.nav-link').click(function(){
      var bg = $(this).data('image');
      $(this).closest('.sectionAnyLookTabs').css('background-image','url('+bg+')');
	});
  $('.drawer-close').click(function(){
  
    $( '.js-go-cart-drawer-close' ).trigger( "click" );
    
  });


});




/*Task 21F-YO4-I5Z END*/

// $(window).on('resize',function() {
//     if ($(window).width() < 992) {
//         $(document).on('click','.headerNav ul>li.dropdownItem>a',function (e) {
//             e.preventDefault();
//             $(this).parent('li').children('.megaMenu').slideToggle();
//             $(this).parent('li').toggleClass('dropdownMenuOpen');
//         });
//     }
// }).trigger('resize');

/* MN hide HexTom EPB on special offer pages */
(function(){
  var path=(window.location.pathname||'').replace(/\/$/, '');
  if(path!=='/pages/special-offer-page' && path!=='/pages/special-offer-page-v2') return;
  document.documentElement.classList.add('mn-hide-epb');
  if(document.body) document.body.classList.add('mn-hide-epb');
  var style=document.createElement('style');
  style.textContent='#epb_container,#epb_background,#epb_bar{display:none!important;visibility:hidden!important;height:0!important;max-height:0!important;overflow:hidden!important;padding:0!important;margin:0!important;}body.mn-hide-epb,html.mn-hide-epb body{padding-top:0!important;}';
  (document.head||document.documentElement).appendChild(style);
  function hide(){['epb_container','epb_background','epb_bar'].forEach(function(id){var el=document.getElementById(id);if(el){el.style.setProperty('display','none','important');el.setAttribute('hidden','true');}});if(document.body)document.body.style.setProperty('padding-top','0px','important');}
  hide();
  document.addEventListener('DOMContentLoaded',hide);
  window.addEventListener('load',hide);
  [300,800,1500,3000,5000,8000].forEach(function(ms){setTimeout(hide,ms);});
})();

